/**
 * Builds consumer-visible collection pages from Shopify paginated chunks
 * (corporate/SYOB products are already omitted server-side in Liquid).
 */
(function () {
  var MAX_SHOPIFY_PAGES = 20;
  var CACHE_PREFIX = 'ats-consumer-index:';

  function n(s) {
    return (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function extractId(card) {
    return card.getAttribute('data-product-id') || null;
  }

  function gridElementId(sectionId) {
    return 'ATS-CollectionGrid-' + sectionId;
  }

  function cardsHtmlFromGridElement(grid) {
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('[data-ats-product-card]')).map(function (card) {
      return card.outerHTML;
    });
  }

  function getCacheKey() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return CACHE_PREFIX + url.pathname + url.search;
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(getCacheKey());
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeCache(cardsHtml, shopifyPages) {
    try {
      sessionStorage.setItem(
        getCacheKey(),
        JSON.stringify({ cards: cardsHtml, shopifyPages: shopifyPages, ts: Date.now() })
      );
    } catch (e) {}
  }

  function clearCache() {
    try {
      sessionStorage.removeItem(getCacheKey());
    } catch (e) {}
  }

  function parseVisibleCardsFromHtml(html, sectionId) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // getElementById: section ids contain "--" which breaks querySelector
    var grid = doc.getElementById(gridElementId(sectionId));
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('[data-ats-product-card]'));
  }

  function mergeCardsUnique(cardLists) {
    var seen = new Set();
    var out = [];
    cardLists.forEach(function (cards) {
      cards.forEach(function (card) {
        var id = extractId(card);
        if (!id || seen.has(id)) return;
        seen.add(id);
        out.push(card.outerHTML);
      });
    });
    return out;
  }

  function buildFetchUrl(shopifyPage, sectionId) {
    var pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('section_id');
    if (shopifyPage <= 1) pageUrl.searchParams.delete('page');
    else pageUrl.searchParams.set('page', String(shopifyPage));

    var fetchUrl = new URL(pageUrl.toString());
    fetchUrl.searchParams.set('section_id', sectionId);
    return fetchUrl.toString();
  }

  async function fetchShopifyPageHtml(shopifyPage, sectionId) {
    var res = await fetch(buildFetchUrl(shopifyPage, sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    return res.text();
  }

  function getConsumerPageFromUrl() {
    var p = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }

  function slicePage(cardsHtml, pageSize, pageNum) {
    var start = (pageNum - 1) * pageSize;
    return cardsHtml.slice(start, start + pageSize);
  }

  function cardsHtmlJoin(slice) {
    return slice.join('');
  }

  function renderPagination(container, consumerPages, currentPage) {
    if (!container) return;
    if (consumerPages <= 1) {
      container.innerHTML = '';
      container.classList.remove('ats-consumer-pagination-wrap--loading');
      return;
    }

    var url = new URL(window.location.href);
    url.searchParams.delete('section_id');

    function pageHref(p) {
      var u = new URL(url.toString());
      if (p <= 1) u.searchParams.delete('page');
      else u.searchParams.set('page', String(p));
      return u.toString();
    }

    var html = '<div class="pagination">';
    if (currentPage > 1) {
      html +=
        '<span class="prev"><a href="' +
        pageHref(currentPage - 1) +
        '" title="Previous"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"/></svg><span class="icon__fallback-text">Previous</span></a></span>';
    }

    for (var i = 1; i <= consumerPages; i++) {
      if (i === currentPage) {
        html += '<span class="page current">' + i + '</span>';
      } else {
        html += '<span class="page"><a href="' + pageHref(i) + '">' + i + '</a></span>';
      }
    }

    if (currentPage < consumerPages) {
      html +=
        '<span class="next"><a href="' +
        pageHref(currentPage + 1) +
        '" title="Next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"/></svg><span class="icon__fallback-text">Next</span></a></span>';
    }

    html += '</div>';
    container.innerHTML = html;
    container.classList.remove('ats-consumer-pagination-wrap--loading');
  }

  function setGridLoading(grid, loading) {
    if (!grid) return;
    grid.classList.toggle('ats-consumer-grid--loading', loading);
  }

  async function buildVisibleIndex(root) {
    var sectionId = root.getAttribute('data-section-id');
    var shopifyPages = parseInt(root.getAttribute('data-shopify-pages') || '1', 10);
    if (isNaN(shopifyPages) || shopifyPages < 1) shopifyPages = 1;
    shopifyPages = Math.min(shopifyPages, MAX_SHOPIFY_PAGES);

    var cached = readCache();
    if (
      cached &&
      cached.cards &&
      cached.cards.length > 0 &&
      cached.shopifyPages === shopifyPages
    ) {
      return cached.cards;
    }

    var cardLists = [];
    for (var p = 1; p <= shopifyPages; p++) {
      var html = await fetchShopifyPageHtml(p, sectionId);
      cardLists.push(parseVisibleCardsFromHtml(html, sectionId));
    }

    var merged = mergeCardsUnique(cardLists);
    if (merged.length > 0) {
      writeCache(merged, shopifyPages);
    } else {
      clearCache();
    }
    return merged;
  }

  function dispatchReady(detail) {
    document.dispatchEvent(new CustomEvent('ATS:CONSUMER_PAGINATION_READY', { detail: detail }));
  }

  async function initRoot(root) {
    var sectionId = root.getAttribute('data-section-id');
    var pageSize = parseInt(root.getAttribute('data-consumer-page-size') || '80', 10);
    if (isNaN(pageSize) || pageSize < 1) pageSize = 80;

    var grid = document.getElementById(gridElementId(sectionId));
    var paginationEl = document.getElementById('ATS-ConsumerPagination');
    if (!grid) return;

    var liquidFallbackHtml = cardsHtmlFromGridElement(grid);

    setGridLoading(grid, true);

    var allCardsHtml;
    try {
      allCardsHtml = await buildVisibleIndex(root);
    } catch (e) {
      setGridLoading(grid, false);
      return;
    }

    if (!allCardsHtml.length && liquidFallbackHtml.length) {
      allCardsHtml = liquidFallbackHtml;
      clearCache();
    }

    if (!allCardsHtml.length) {
      setGridLoading(grid, false);
      if (paginationEl) {
        paginationEl.innerHTML = '';
        paginationEl.classList.remove('ats-consumer-pagination-wrap--loading');
      }
      return;
    }

    var consumerPages = Math.max(1, Math.ceil(allCardsHtml.length / pageSize));
    var currentPage = getConsumerPageFromUrl();
    if (currentPage > consumerPages) currentPage = consumerPages;

    var pageSlice = slicePage(allCardsHtml, pageSize, currentPage);
    grid.innerHTML = cardsHtmlJoin(pageSlice);
    setGridLoading(grid, false);

    renderPagination(paginationEl, consumerPages, currentPage);

    var countEl = root.querySelector('[data-ats-count]');
    if (countEl) {
      countEl.textContent = allCardsHtml.length + ' Products';
    }

    dispatchReady({
      sectionId: sectionId,
      fullVisibleHTML: cardsHtmlJoin(allCardsHtml),
      consumerPageHTML: grid.innerHTML,
      currentConsumerPage: currentPage,
      consumerPages: consumerPages,
      totalVisible: allCardsHtml.length,
    });

    if (typeof theme !== 'undefined' && theme.reinitProductGridItem) {
      theme.reinitProductGridItem();
    }
  }

  var initPromise = null;

  function init() {
    var roots = document.querySelectorAll('[data-consumer-pagination="true"]');
    if (!roots.length) return;

    if (initPromise) return initPromise;

    initPromise = Promise.all(Array.from(roots).map(initRoot)).finally(function () {
      initPromise = null;
    });
    return initPromise;
  }

  function onCollectionUpdated() {
    clearCache();
    var roots = document.querySelectorAll('[data-consumer-pagination="true"]');
    roots.forEach(function (root) {
      var paginationEl = document.getElementById('ATS-ConsumerPagination');
      if (paginationEl) paginationEl.classList.add('ats-consumer-pagination-wrap--loading');
    });
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('ATS:COLLECTION_UPDATED', onCollectionUpdated);

  window.ATSConsumerPagination = {
    init: init,
    clearCache: clearCache,
    rebuild: onCollectionUpdated,
  };
})();
